module.exports = __webpack_public_path__ + "img/wave-footer.849a933d.svg";